import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(IUserAccessor, 'IUserAccessor');
initMetadataForInterface(IPlatformUserProvider, 'IPlatformUserProvider', VOID, VOID, VOID, [1]);
//endregion
function IUserAccessor() {
}
function IPlatformUserProvider() {
}
//region block: exports
export {
  IUserAccessor as IUserAccessor2r676j1t9f9ew,
  IPlatformUserProvider as IPlatformUserProvidernolzgfyci6us,
};
//endregion

